window.app = window.app || {};

window.app.resourcesList = {
    el: {
        body: document.querySelector('body'),
        section: document.querySelector('.mt-resources-list'),
        sectionHeader: document.querySelector('.mt-resources-list__heading'),
        btns: document.querySelectorAll('.mt-resource-item__btn')
    },

    init: function () {
        const _this = this;
        if (!_this.el.section) return;

       _this.el.btns.forEach(btn => {
            const item = btn.closest('.mt-resource-item');
            const itemTitle = item.querySelector('.mt-resource-item__title');
            btn.addEventListener('click', e => {
                if (btn.classList.contains('mt-resource-item__btn--toggle')) {
                    e.preventDefault();
                    item.classList.toggle('active');
                }

                // Additional DL events
                itemTitle && app.dl.customClick(itemTitle.innerText, { location: _this.el.sectionHeader.innerText });
            });
       });
    }
}

window.app.resourcesList.init();